import React, { Component } from 'react';
import { withBreakpoint } from '../../enhancers';
import { connect } from 'react-redux';
import { goToInitialStep } from '../PaymentPage/PaymentWizard/actions';
import Matrix from './Matrix';
import styles from './MatrixPage.scss';
import MatrixPageHeader from './Matrix/MatrixPageHeader';
import MatrixPageFooter from './Matrix/MatrixPageFooter/MatrixPageFooter';
import { compose, lifecycle } from 'recompose';

class MatrixPage extends Component {
    state = {
      isShortList: true,
    };

    handleShowMoreLessButtonClick = () => {
      this.setState(
        prevState => ({ isShortList: !prevState.isShortList }),
        () => {
          setTimeout(() => {
            const elementOffsetTop = document.getElementsByClassName(styles.matrix)[0]
              .offsetTop;
            window.scrollTo(0, elementOffsetTop - 20);
          }, 0);
        },
      );
    };

    render() {
      const { isShortList } = this.state;

      return (
        <div className="ui-canvas ui-canvas--full white-bgr" data-testid="matrixPage__Container">
          <section className={styles.root}>
            <MatrixPageHeader />
            <div className={styles.matrix}>
              <Matrix
                service="insights"
                isShortList={isShortList}
                handleShowMoreLessButtonClick={this.handleShowMoreLessButtonClick}
                        />
              <Matrix
                service="tipping"
                isShortList={isShortList}
                handleShowMoreLessButtonClick={this.handleShowMoreLessButtonClick}
                        />
              <Matrix
                service="ultimate"
                isShortList={isShortList}
                handleShowMoreLessButtonClick={this.handleShowMoreLessButtonClick}
                        />
            </div>
            <MatrixPageFooter />
          </section>
        </div>
      );
    }
}

const MatrixPageContainer = withBreakpoint(MatrixPage);

export default compose(
  connect(
    // eslint-disable-next-line no-empty-pattern
    ({}) => ({}),
    { goToInitialStep },
  ),
  lifecycle({
    componentDidMount() {
      const { goToInitialStep } = this.props;

      goToInitialStep();
    },
  }),
)(MatrixPageContainer);
